import request from '@/utils/request'
const platform = localStorage.getItem('platform')

export function getSysLogs(data) {
    return request.get(`/${platform}/sys_logs`, data)
}
